import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { pointerEventsStyles, theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarFloatingContainer = (props: Props) => {
  const { children } = props;

  // ─────────────────────────────────────────────────────────────────────

  return <View style={[styles.container, pointerEventsStyles['box-none']]}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFill,
    zIndex: theme.zIndex.fixed,
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing['4'],
    maxWidth: 1520,
    marginHorizontal: 'auto',
    paddingTop: theme.spacing['4'],
    paddingHorizontal: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren;
